
export const environment = {
  production: true,
  apiBase:"https://comppbmprodapi.azurewebsites.net/",
  apiBaseAraya:"https://comppbm-araya-api-prod.azurewebsites.net/",
  //apiBase:"https://dev-compdmepbmapi.azurewebsites.net/",  
  //apiBase: 'https://comppbmuatapi.azurewebsites.net/',
  //apiBase: 'http://localhost:908/',
  //apiBase: 'http://localhost:8088/',
  time:300000,
  externalAuth: {
    spaCallbackPath: 'signin-entra',
    challengePath: 'api/ExternalAuth/ExternalLogin',
    callbackPath: 'api/ExternalAuth/ExternalLoginCallback',
    providers: {
      entraId: { enabled: true, label: 'Microsoft' },
      microsoft: { enabled: false, label: 'Microsoft (Personal)' },
      google: { enabled: false, label: 'Google' }
    }
  }
};
